import './App.css';
import React from 'react';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Cart from './components/Cart';
import AddItem from './components/AddItem';
import Iot1 from './components/Iot1';
import ItemDetailContainer from './components/ItemDetailContainer';
import ItemListContainer from './components/ItemListContainer';
import NavBar from './components/NavBar';
import CartProvider from './context/CartContext';

function App() {
  return (
    <>
    <BrowserRouter>
      <CartProvider>
      <NavBar />
      <Routes>
        <Route path='/' element={<ItemListContainer texto='Titulo 111' />} />
        <Route path='/categoria/:categoriaId' element={<ItemListContainer texto='Titulo 222' />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/addItem' element={<AddItem />} />
        <Route path='/iot1' element={<Iot1 />} />
        <Route path='/detalle/:detalleId' element={<ItemDetailContainer />} />
      </Routes>
      </CartProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
